import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Flex, Input,  Select,  Typography } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { clubTypesAction } from 'src/store/Slices/Administrator/ClubTypesSlice';

const AddEditClubTypesModal = ({ visible, setVisible, clubTypeInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [name, setName] = useState()

    useEffect(() => {
        setName()
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(clubTypeInfo?.name)
        }
    }, [visible, clubTypeInfo])

    const onClickSubmit = () => {
        dispatch(clubTypesAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: {
                id: visible.flag !== 'add' ? clubTypeInfo.id : undefined,
                name : name,
            }
        })).then(() => {
            dispatch(clubTypesAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
            })
        })
    }


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить тип клуба' : 'Редактировать тип клуба'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditClubTypesModal